export default "__VITE_ASSET__DgNg3Bni__"